import { useTheme } from "@emotion/react";
import { Box, CircularProgress, Grid, IconButton, MenuItem, Paper, Select, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { FormikContext, FormikProvider, useFormik } from "formik";
import CustomInputField from "ui-components/formik/CustomInputField";
import * as Yup from "yup";
import { amountInWords, currencyInputProps, formatAllowsNegativeCurrency, interestOptions } from "utils";
import { FetchAllCurrencyLists } from "api/utils";
import { Primary } from 'ui-components/Buttons';

const ShowInterestPopup = ({ currentRow, handleClose, handleSubmit, isShowingInterest = false }) => {
    // console.log(currentRow, "currentRow")
    const theme = useTheme();
    const [selectedInterest, setSelectedInterest] = useState(null)
    const { data: currencyList, isLoading: isLoadingCurrency } =
        FetchAllCurrencyLists();

    const validations = Yup.object(
        {
            interested_amount: Yup.string()
                .required("Please enter valid amount")
                .test("valid-amount", "Please enter valid amount", (value) => {
                    if (!value) return false;
                    // Remove commas and check if it's a valid number
                    const numberValue = value.replace(/,/g, '');
                    return !isNaN(numberValue) && Number(numberValue) > 0;
                })
        }
    )

    const formik = useFormik({
        initialValues: {
            interested_amount: 0,
            currency_id: !isLoadingCurrency ? currencyList?.[0]?._id : null
        },
        // validateOnMount: true,
        validationSchema: validations,
        onSubmit: (values, { setSubmitting }) => {
            handleSubmit({ row: currentRow, values });
        },
    });

    // const currencyIcon = (currentRow && currentRow?.currency_info && currentRow?.currency_info?.code ? currentRow?.currency_info?.code : "₹")
    // console.log(currentRow?.currency_info[0]?.code,"urrentRow?.currency_info[0]?.code")
    const [currencyIcon, setCurrencyIcon] = useState("₹");

    React.useEffect(() => {
        if (!isLoadingCurrency && currencyList && Array.isArray(currencyList)) {
            setCurrencyIcon(currencyList?.[0]?.code);
            formik.setFieldValue("currency_id", currencyList[0]?._id);
        }
    }, [isLoadingCurrency, currencyList])

    return (
        <Paper
            sx={{
                background: theme.palette.customColors.whiteBG,
                borderRadius: "20px",
            }}
        >
            <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
                <CloseIcon width={40} height={40} onClick={handleClose} />
            </IconButton>
            <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <Grid display={"grid"} container padding={"1.5rem"} gap={"1.5rem"}>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    fontSize: "1.5rem",
                                    fontWeight: 700,
                                    lineHeight: "28px",
                                    color: theme.palette.customColors.g300,
                                }}
                            >
                                Investment Amount
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: "1rem",
                                    fontWeight: 500,
                                    lineHeight: "24px",
                                    color: theme.palette.customColors.g200,
                                }}
                            >
                                Provide your investment amount
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Tooltip title={amountInWords(formik.values.interested_amount, currencyIcon)}>
                                <CustomInputField
                                    name="interested_amount"
                                    label={"Enter Investment Amount"}
                                    value={formatAllowsNegativeCurrency(formik.values.interested_amount, currencyIcon == "₹" ? "en-IN" : "en-US")?.replaceAll("--", "")}
                                    onChange={(e) => {
                                        formik.setFieldValue("interested_amount",
                                            formatAllowsNegativeCurrency(e.target.value, currencyIcon == "₹" ? "en-IN" : "en-US")?.replaceAll("--", "")
                                        );
                                        setSelectedInterest(null)
                                    }}
                                    InputProps={{
                                        // startAdornment: Adornment
                                        ...currencyInputProps,
                                        startAdornment: (
                                            <Box pl={2} mr={-1}>{(currencyIcon)}</Box>
                                        ),
                                        endAdornment: (
                                            !isLoadingCurrency && currencyList && <Select
                                                className="selecttt"
                                                sx={{
                                                    "::before": { border: "none !important" },
                                                    border: "none !important",
                                                    minWidth: "fit-content",
                                                    '& >  .MuiSelect-select': {
                                                        paddingRight: "2rem !important"
                                                    }
                                                }}
                                                value={formik.values?.currency_id}
                                                onChange={(e) => {
                                                    // console.log(currencyList?.find(item => item?._id === e.target.value),"edefe")
                                                    // formik.setFieldValue(
                                                    //     "currency",
                                                    //     currencyList?.find(item => item?._id === e.target.value)?.code
                                                    // );
                                                    setCurrencyIcon(currencyList?.find(item => item?._id === e.target.value)?.code)
                                                    formik.setFieldValue(
                                                        "currency_id",
                                                        e.target.value
                                                    )
                                                }
                                                }
                                            >
                                                {/* <MenuItem value={"$"}>USD</MenuItem>
                                  {<MenuItem value={"₹"}>INR</MenuItem>} */}
                                                {currencyList?.map((item) => (
                                                    <MenuItem type="button" value={item?._id}>
                                                        {item?.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        ),
                                    }}
                                    sx={{ marginBottom: formik.errors.interested_amount ? 0 : "inherit" }}
                                />
                            </Tooltip>
                        </Grid>
                        <Grid item sx={12} className="grid">
                            {
                                interestOptions((currencyIcon))?.map(item => {
                                    return (
                                        <button type="button" className={`item ${item.label === selectedInterest && "selected-item"}`} onClick={() => { setSelectedInterest(item.label); formik.setFieldValue("interested_amount", item.value); }}>{item.label}</button>
                                    )
                                })
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Primary
                                type="submit"
                                fullWidth
                                disabled={isShowingInterest}
                                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
                            >
                                {isShowingInterest ? <CircularProgress sx={{ color: "white", marginInline: 'auto' }} size={'1.4rem'} /> : "Submit"}
                            </Primary>
                        </Grid>
                    </Grid>
                </form>
            </FormikProvider>
        </Paper>
    );
};

export default ShowInterestPopup;
